import { useEffect, useState } from "react";
import { Tooltip } from "antd";

export function EcomChatToggle() {
  const [isOpen, setIsOpen] = useState(!!window.__kappEcomChatOpen);
  const [unread, setUnread] = useState(Number(window.__kappEcomChatUnread || 0));
  const [onlineCount, setOnlineCount] = useState(Number(window.__kappEcomChatOnline || 0));

  useEffect(() => {
    const onState = (e) => setIsOpen(!!e?.detail?.open);
    const onUnread = (e) => {
      const n = Number(e?.detail?.count || 0);
      setUnread(Number.isFinite(n) && n > 0 ? Math.floor(n) : 0);
    };
    const onOnline = (e) => {
      const n = Number(e?.detail?.count || 0);
      setOnlineCount(Number.isFinite(n) && n >= 0 ? Math.floor(n) : 0);
    };
    window.addEventListener("kapp:ecomchat-state", onState);
    window.addEventListener("kapp:ecomchat-unread", onUnread);
    window.addEventListener("kapp:ecomchat-online", onOnline);
    return () => {
      window.removeEventListener("kapp:ecomchat-state", onState);
      window.removeEventListener("kapp:ecomchat-unread", onUnread);
      window.removeEventListener("kapp:ecomchat-online", onOnline);
    };
  }, []);

  const toggle = () => {
    const next = !isOpen;
    setIsOpen(next);
    window.dispatchEvent(new CustomEvent("kapp:toggle-ecomchat", { detail: { open: next } }));
  };

  const tooltipContent = (
    <div style={{ textAlign: "center", lineHeight: 1.5 }}>
      <div style={{ fontWeight: 700, marginBottom: 2 }}>Ecom Chat</div>
      <div>{onlineCount} active user{onlineCount !== 1 ? "s" : ""}</div>
      <div>{unread} unread chat{unread !== 1 ? "s" : ""}</div>
    </div>
  );

  return (
    <div className="topbar-item" style={{ padding: "0 4px" }}>
      <Tooltip title={tooltipContent}>
        <button
          type="button"
          className="btn btn-icon btn-clean btn-lg position-relative"
          onClick={toggle}
          aria-label={isOpen ? "Close ecom chats" : "Open ecom chats"}
          style={{ padding: 0, border: "none", background: "transparent" }}
        >
          <svg width={26} height={26} viewBox="0 0 24 24" fill="none" stroke={isOpen ? "#e81e61" : "#555"} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="9" cy="21" r="1" />
            <circle cx="20" cy="21" r="1" />
            <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
            <path d="M15 3h5a1 1 0 0 1 1 1v3.5a1 1 0 0 1-1 1h-2l-1.5 1.5V8.5H15a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z" fill={isOpen ? "#e81e61" : "#555"} stroke="none" opacity="0.85" />
            <circle cx="16" cy="5.8" r="0.4" fill="#fff" />
            <circle cx="17.5" cy="5.8" r="0.4" fill="#fff" />
            <circle cx="19" cy="5.8" r="0.4" fill="#fff" />
          </svg>
          {unread > 0 && (
            <span style={{
              position: "absolute",
              top: -4,
              right: -6,
              minWidth: 18,
              height: 18,
              borderRadius: 9,
              background: "#e81e61",
              color: "#fff",
              fontSize: 11,
              fontWeight: 700,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "0 4px",
              lineHeight: 1,
              border: "2px solid #fff",
            }}>
              {unread > 99 ? "99+" : unread}
            </span>
          )}
          {onlineCount > 0 && (
            <span style={{
              position: "absolute",
              bottom: -4,
              right: -6,
              minWidth: 18,
              height: 18,
              borderRadius: 9,
              background: "#10b981",
              color: "#fff",
              fontSize: 11,
              fontWeight: 700,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "0 4px",
              lineHeight: 1,
              border: "2px solid #fff",
            }}>
              {onlineCount > 99 ? "99+" : onlineCount}
            </span>
          )}
        </button>
      </Tooltip>
    </div>
  );
}
